import { initializeBooks } from "./rhea-book-viewer/loader.js";

// The translation library is deliberately not processed by Vite, so Drupal's
// Locale module can discover its literal Drupal.t() calls in the original
// asset. The viewer bundle only consumes the prepared values.
export const viewerI18n = Drupal.rheaViewerI18n ?? {};

/**
 * Initializes viewer roots exactly once for Drupal AJAX and BigPipe contexts.
 */
export async function attachViewers(
  context,
  onceApi = once,
  initialize = initializeBooks,
) {
  const elements = onceApi("rhea-book-viewer", ".rhea-book-viewer", context);

  return initialize({ documentRoot: document, elements, i18n: viewerI18n });
}

/**
 * Destroys viewers whose Drupal context is being removed from the DOM.
 */
export function detachViewers(context, trigger, onceApi = once) {
  if (trigger !== "unload") return;

  for (const element of onceApi.filter(
    "rhea-book-viewer",
    ".rhea-book-viewer",
    context,
  )) {
    element.rhea?.destroy();
  }
  onceApi.remove("rhea-book-viewer", ".rhea-book-viewer", context);
}

Drupal.behaviors.rheaBookViewer = {
  attach(context) {
    void attachViewers(context);
  },

  detach(context, _settings, trigger) {
    detachViewers(context, trigger);
  },
};
